import { useState } from 'react';
import apiInstance from '../../../services/ServiceApi'; // Ajusta la importación según tu estructura.
import Reportes from './ListReports';
import DataGridReport from './ReportPreview';
import { Container, Modal, Box, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

const Reports = () => {
  const [datos, setDatos] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const handleReportAction = (formData) => {
    

    // Define el endpoint dependiendo de la acción
    let endpoint = 'reporte/';
    if (formData.actionType !== 'preview') {
      endpoint = 'reporteExcel/';
    }   
    // Realiza la solicitud
    apiInstance.post(endpoint, formData)
      .then(response => {
        if(formData.actionType === 'preview'){
           setDatos(response.data) 
           setModalOpen(true);
        }
        else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'reporte.xlsx'); // o el nombre de archivo que prefieras
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        }
         
        
        console.log(response.data);
      })
      .catch(error => {
        console.error("Error al generar el reporte:", error);
      });
  };
  return (
    <Container>
      <Reportes onAction={handleReportAction} />
      <Modal
        open={isModalOpen}
        onClose={()=>setModalOpen(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', 
        justifyContent: 'center', width: '80%', margin: 'auto', top: '50%', 
          position: 'absolute', 
          transform: 'translate(-50%, -50%)', 
          left: '50%', 
        padding: '2rem', bgcolor: 'background.paper' }}>

       
          <IconButton
            aria-label="close"
            onClick={()=>setModalOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <Close />
          </IconButton>
          <Typography id="modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
           Reporte
          </Typography>
          {datos && <DataGridReport datos={datos} />}
        </Box>
      </Modal>
    </Container>
  );
}

export default Reports;